import { motion, useReducedMotion } from "framer-motion";

/** Calm, water-surfacing reveal. Content rises and settles as if surfacing. */
export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduce) {
    const Tag = as;
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y, filter: "blur(6px)" }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, margin: "-12% 0px -12% 0px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

/** Masked, line-by-line display reveal for the signature on-load moment. */
export const LineReveal = ({ lines, className = "", lineClassName = "", startDelay = 0.15 }) => {
  const reduce = useReducedMotion();
  return (
    <h1 className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            aria-hidden="true"
            className={`block ${lineClassName}`}
            initial={reduce ? { y: 0 } : { y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay: startDelay + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
};
